/**
 * @param {string} dateStart in ISO 8601
 * @param {string} dateEnd in ISO 8601
 * @param {string} format
 * @returns {string}
 */
export function formatDatesRange(dateStart, dateEnd, format) {
    dateStart = moment(dateStart).format(format);
    dateEnd = moment(dateEnd).format(format);
    if (dateStart === dateEnd) {
        return dateStart;
    } else {
        return dateStart + ' - ' + dateEnd;
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/date-time-formatting.js